export default "__VITE_ASSET__BwYSEfUq__"